import Vue from 'vue'
import Router from 'vue-router'


Vue.use(Router)

const router = new Router({
  routes: [
  {
    path: '*',
    redirect:'/'
  },
  {
    path: '/',
    name: "default",
    component: () => import('@/pages/default.vue')
  },
  {
    path: '/downloadNota/:params',
    name: "downloadNota",
    component: () => import('@/pages/donwloadNota.vue'),
    props: true,
  },
  {
    path: '/viewNota/:params',
    name: "viewNota",
    component: () => import('@/pages/viewNota.vue'),
    props: true,
  },
  {
    path: '/descargarNota/:params',
    name: "descargarNota",
    component: () => import('@/pages/descargarNota.vue'),
    props: true,
  },
  {
    path: '/verNota/:params',
    name: "verNota",
    component: () => import('@/pages/verNota.vue'),
    props: true,
  },
  // --------- Nay --------------
]})



export default router;